import axios from 'axios';
import { instance } from '..';

export const getPresignedUrlApi = (extension: string) => {
  return instance.get(
    `${process.env.REACT_APP_API_POST_IMAGE}/upload/preSigned`,
    {
      // 프리사인 url요청은 운영서버를 통해서 수행
      params: { fileExtension: extension },
    },
  );
};

export const imageUploadApi = (presignedUrl: string, file: File) => {
  return axios.put(presignedUrl, file, {
    headers: { 'Content-Type': file.type },
  });
};
